import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import AddYear from "../../Components/Cards/AddYear/AddYear";
import DashboardCard from "../../Components/Cards/DashboardCards/DashboardCard";
import DeleteCard from "../../Components/Cards/DeleteCard/DeleteCard";
import GraphCard from "../../Components/Cards/GraphCard/GraphCard";
import UnpaidCard from "../../Components/Cards/UnpaidCard/UnpaidCard";
import api from "../../utils/api";
import "./dashboard.css";

const Dashboard = () => {
  const [fees, setFees] = useState({
    paid: "",
    unpaid: "",
    feesPaid: [],
    feesUnpaid: [],
  });
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const fetchFees = async () => {
    await api
      .get("/feesreport/status", {
        params: {
          from: selectedYear?.from,
          to: selectedYear?.to,
        },
      })
      .then((response) => response.data)
      .then((data) => {
        setFees(data);
      });
  };

  const fetchData = async () => {
    await api
      .get("/academic")
      .then((response) => response.data)
      .then((data) => {
        const activeYear = data?.find((item) => item?.is_active);
        const formattedActiveYear = {
          label:
            new Date(activeYear?.start_date).getFullYear() +
            "-" +
            new Date(activeYear?.end_date).getFullYear(),
          from: activeYear?.start_date,
          to: activeYear?.end_date,
          id: activeYear?.id,
        };
        setSelectedYear(formattedActiveYear);
        setAcademicYears(
          data
            ?.filter((item) => !item?.is_active)
            .map((item) => ({
              label:
                new Date(item?.start_date).getFullYear() +
                "-" +
                new Date(item?.end_date).getFullYear(),
              from: item?.start_date,
              to: item?.end_date,
              id: item?.id,
            }))
        );
      });
  };

  const fetchData2 = async (year) => {
    await api
      .put("/academic/" + year?.id, {
        is_active: true,
      })
      .then((data) => {
        fetchData();
        toast.success("Academic year activated!");
      });
  };

  useEffect(async () => {
    fetchFees();
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const handleYearChange = (e) => {
    const year = academicYears.find((y) => y.label === e.target.value);
    setOpen(true);
    setSelectedYear(year);
  };

  return (
    <div className="dashboard">
      <div className="dashboard__left_container">
        <div className="dashboard__left__top_container">
          <DashboardCard main={fees.paid ?? 0} sub="Fees Paid" />
          <DashboardCard main={fees.unpaid ?? 0} sub="Fees Overdue" />
        </div>
        <UnpaidCard />
      </div>
      <div className="dashboard__right_container">
        <div
          style={{
            marginBottom: "1rem",
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            paddingLeft: "1rem",
          }}
        >
          <div className="dashboard__year_selector" style={{ marginleft: "20px", marginBottom: "16px" }}>
            <label htmlFor="academicYear" style={{ marginRight: "8px" }}>
              Academic Year
            </label>
            <select
              id="academicYear"
              value={selectedYear?.label}
              onChange={handleYearChange}
              style={{ padding: "8px", borderRadius: "8px",  backgroundColor: "#efefef" }}
              className="custom-select"
            >
              {!selectedYear &&
                <option value={""} style={{ pointerEvents: "none" }} disabled>
                  {"Select Academic Year"}
                </option>}
              {academicYears?.map((year) => (
                <option key={year?.label} value={year?.label}>
                  {year?.label}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={() => setOpen2(true)}
            className="about_us__top_button"
            style={{ marginBottom: "25px" }}
          >
            Add Date Range
          </button>
        </div>
        <GraphCard
          paid={"₹" + fees.paid}
          feesUnpaid={fees.feesUnpaid}
          feesPaid={fees.feesPaid}
          due={"₹" + fees.unpaid}
        />
      </div>
      {open ? (
        <DeleteCard
          btn="Confirm"
          msg="Are you sure you want to change academic year ?"
          close={() => {
            setOpen(false);
            fetchData();
          }}
          del={() => {
            setOpen(false);
            fetchData2(selectedYear);
          }}
        />
      ) : null}
      {open2 ? (
        <AddYear
          close={() => {
            setOpen2(false);
          }}
          btn="Add"
          fetchData={fetchData}
        />
      ) : null}
    </div>
  );
};

export default Dashboard;
